export const TYPE_PDP_TOP = 'buyTogetherWith'
export const TYPE_CAT_PAGES_XSELL_SECOND_WID = 'categorySecond'
export const TYPE_PDP_CENTER = 'sliderAvailable'
export const TYPE_PDP_NA = 'sliderOutOfStock'
export const TYPE_PDP_AV = 'sliderNoSuccessor'
export const TYPE_PDP_RX = 'sliderForPrescriptedMedicine'
export const TYPE_START_PAGE = 'startPage'
export const TYPE_START_PAGE_BOTTOM = 'startPageBottom'
export const TYPE_CATEGORY = 'category'
export const TYPE_ADD_TO_CART_TOP = 'addToCartTop' // popular products
export const TYPE_ADD_TO_CART_CENTER = 'addToCartCenter' // recommended products
export const TYPE_CART_TOP = 'cartTop'
export const TYPE_CART_BOTTOM = 'cartBottom'
export const TYPE_NU3_ADD_TO_CART_BOTTOM = 'nu3AddToCartBottom'
export const TYPE_HOME = 'home'
export const TYPE_SEARCH_NO_RESULTS = 'sliderNoSearchResults'
export const TYPE_PDP_SLIDER_TOP = 'pdpSliderTop'
export const TYPE_PDP_SLIDER_TOP_NEW = 'pdpSliderTopNew'
export const TYPE_DELIVERY_TRACKING = 'deliveryTracking'
export const TYPE_MY_ACCOUNT_OVERVIEW = 'myAccountOverview'
export const TYPE_ABO_PAGE = 'aboService'
export const TYPE_REDPOINTS_PAGE = 'redpoints'
export const TYPE_OWN_BRANDS_IN_CART = 'ownBrandsInCart'
export const TYPE_ONE_OWN_BRAND_IN_CART = 'oneOwnBrandInCart'
export const TYPE_SELLER_MODAL = 'sellerModal'

export const CROSSSELL_CLASSNAME = 'crosssell-widget'
export const CROSSSELL_ATTR_ANALYTICS_NAME = 'crosssell-widget'
export const ANALYTICS_ATTR_IMAGE = 'item-image'
export const ANALYTICS_ATTR_TITLE = 'item-title'

// NB remove when the CRO-596 experiment is done
export const TYPE_PDP_SLIDER_TOP_EXPERIMENT = 'pdpSliderTopExperiment'

export const TYPE_RETAIL_SHOWCASE_PAGE = 'retailShowCasePage'

export const AT_TYPE_CART_TOP = 50
export const AT_TYPE_CART_BOTTOM = 51
export const MP_AT_TYPE_CART_TOP = 361
export const MP_AT_TYPE_CART_BOTTOM = 362

export const MP_COM_AID = '000016f3-496c2984-7951-4ed2-b556-1bdfdd0856c4-8'
export const MP_AT_AID = '000016f3-496c2984-7951-4ed2-b556-1bdfdd0856c4-9'

export const DEFAULT_WIDGETS = {
  [TYPE_CAT_PAGES_XSELL_SECOND_WID]: 326,
  [TYPE_PDP_AV]: 316,
  [TYPE_PDP_NA]: 298,
  [TYPE_PDP_CENTER]: 297,
  [TYPE_PDP_RX]: 324,
  [TYPE_PDP_TOP]: 296,
  [TYPE_START_PAGE]: 294,
  [TYPE_START_PAGE_BOTTOM]: 299,
  [TYPE_CATEGORY]: 295,
  [TYPE_ADD_TO_CART_TOP]: 317,
  [TYPE_ADD_TO_CART_CENTER]: 318,
  [TYPE_CART_TOP]: 320,
  [TYPE_CART_BOTTOM]: 321,
  [TYPE_NU3_ADD_TO_CART_BOTTOM]: 319,
  [TYPE_HOME]: 294,
  [TYPE_SEARCH_NO_RESULTS]: 322,
  [TYPE_PDP_SLIDER_TOP]: 323,
  [TYPE_PDP_SLIDER_TOP_EXPERIMENT]: 323,
  [TYPE_PDP_SLIDER_TOP_NEW]: 60,
  [TYPE_DELIVERY_TRACKING]: 328,
  [TYPE_MY_ACCOUNT_OVERVIEW]: 348,
  [TYPE_ABO_PAGE]: 332,
  [TYPE_RETAIL_SHOWCASE_PAGE]: 330,
  [TYPE_OWN_BRANDS_IN_CART]: 329,
  [TYPE_ONE_OWN_BRAND_IN_CART]: 331,
}
